export const formatCurrency = (value: number): string =>
  new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(Number.isFinite(value) ? value : 0);

export const normalizeMoneyValue = (value: number): number =>
  Number.isFinite(value) && value > 0 ? value : 0;
